import { useStyle } from "@features/Addons/style";
import { Button, Radio, Typography } from "@mui/material";
import { transformAddress } from "@features/Addons/utils";
import { IContactAddress } from "@common/Eircode/interface/IAddressForm";

interface IParams {
    selected?: boolean;
    disabledRadio?: boolean;
    address: IContactAddress;
    handleChange?(): void;
}

export const AddAddonAddressOption = (props: IParams) => {
    const { selected, disabledRadio, address, handleChange } = props;
    const { classes } = useStyle({ selected, disabledRadio });

    const fullAddress = transformAddress(address);

    return (
        <Button className={classes.addressContainer} disabled={disabledRadio} onClick={handleChange}>
            {!disabledRadio && <Radio checked={selected} color="secondary" value={fullAddress} />}
            <Typography align="left" color="secondary" variant="small">
                {fullAddress}
            </Typography>
        </Button>
    );
};
